module.exports = __webpack_public_path__ + "static/media/Rec5.ce07c042.png";